module.exports = __webpack_public_path__ + "img/checked.bc3a879b.svg";